import { Link } from 'react-router-dom';
import { Container } from '../ui/Container';
import { Facebook, Twitter, Linkedin, Instagram } from 'lucide-react';

const navigation = {
  social: [
    { name: 'Facebook', href: '#', icon: Facebook },
    { name: 'Twitter', href: '#', icon: Twitter },
    { name: 'LinkedIn', href: 'https://www.linkedin.com/company/i-kiotahub/', icon: Linkedin },
    { name: 'Instagram', href: '#', icon: Instagram },
  ],
};

export function SimpleFooter({ className = '', ...props }: React.HTMLAttributes<HTMLElement>) {
  return (
    <footer className={`bg-gray-900 py-6 ${className}`} aria-labelledby="footer-heading" {...props}>
      <h2 id="footer-heading" className="sr-only">Footer</h2>
      <Container>
        <div className="flex flex-col sm:flex-row items-center justify-between">
          <p className="text-xs leading-5 text-gray-400">
            &copy; {new Date().getFullYear()} i-kiotaHub. Tous droits réservés.
          </p>
          
          <div className="flex space-x-6 mt-4 sm:mt-0">
            {navigation.social.map((item) => (
              <Link
                key={item.name}
                to="/under-development"
                className="text-gray-400 hover:text-gray-300"
              >
                <span className="sr-only">{item.name}</span>
                <item.icon className="h-5 w-5" aria-hidden="true" />
              </Link>
            ))}
          </div>
        </div>
      </Container>
    </footer>
  );
}
